import { useDispatch } from "react-redux";
import { updateConfig } from "../../../../store/slices/CVD/CVDSlice";
import { useSelector } from "react-redux";

const useCompareTab = ({ reportRef }) => {
  const dispatch = useDispatch();
  const {data, activeId, showVersionTwoTable, excelCopyPermission } = useSelector(
    (state) => state.cvd
  );

  const handleAdd = () => {
    dispatch(
      updateConfig((state) => {
        const currentVersions = state.data.map((item) => item.name);
        let versionNumber = 1;
        while (currentVersions.includes(`Version ${versionNumber}`)) {
          versionNumber++;
        }
        const newVersionName = `Version ${versionNumber}`;

        // Disable all existing versions
        state.data.forEach((item) => {
          item.disabled = true;
        });

        // Add the new version and enable it
        state.data.push({ name: newVersionName, disabled: false });
        state.activeId = state.data.length; // Set the activeId to the index of the newly added version.
      })
    );
  };

  const handleClick = (e) => {
    if (e.name === "Version 1") {
      dispatch(updateConfig((state) => (state.activeId = 1)));
    } else {
      const inputString = e?.name;
      const numericPart = inputString.match(/\d+/);
      const numericValue = parseInt(numericPart[0]);
      dispatch(updateConfig((state) => (state.activeId = numericValue)));
    }
  };

  return {
    data,
    activeId,
    showVersionTwoTable,
    handleAdd,
    handleClick,
    excelCopyPermission
  };
};

export default useCompareTab;
